import { render, staticRenderFns } from "./account-groups.vue?vue&type=template&id=e5602e66&"
import script from "./account-groups.vue?vue&type=script&lang=js&"
export * from "./account-groups.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports